import React, { useState } from "react"
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'

import conStyles from "@modules/contrast.module.css"

const AccessibilityChecker = () => {

// function getQueryVariable(variable)
// {
//         var query = window.location.search.substring(1);
//         console.log(query)
//         var vars = query.split("&");
//         console.log(vars)
//         for (var i=0;i<vars.length;i++) {
//                     var pair = vars[i].split("=");
//                     console.log(pair)
//         if(pair[0] === variable){return pair[1];}
//           }
//           return(false);
// }

const [colourForeground, setColourForeground] = useState("#ffffff")
const [colourBackground, setColourBackground] = useState("#333333");
const [colourRatio, setColourRatio] = useState(8.66)
const [colorRating, setColourRating] = useState ("AA")


const hexToRgb = hex =>
  hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
             ,(m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1).match(/.{2}/g)
    .map(x => parseInt(x, 16))
  
function luminanace(r, g, b) {
  var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928
          ? v / 12.92
          : Math.pow( (v + 0.055) / 1.055, 2.4 );
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function contrast(rgb1, rgb2) {
  var lum1 = luminanace(rgb1[0], rgb1[1], rgb1[2]);
  var lum2 = luminanace(rgb2[0], rgb2[1], rgb2[2]);
  var brightest = Math.max(lum1, lum2);
  var darkest = Math.min(lum1, lum2);
  return (brightest + 0.05)
       / (darkest + 0.05);
}

const handleClick = e => {
  const str = colourForeground
  const str2 = colourBackground
  const pattern = new RegExp("^#([a-fA-F0-9]){3}$|[a-fA-F0-9]{6}$");
    if(pattern.test(str) || pattern.test(str2) ) {
      const gcRC1 = hexToRgb(colourForeground)
      const gcRC2 = hexToRgb(colourBackground)
    if (isNaN(contrast(gcRC1, gcRC2))) {
      console.log("Fail")
    } else {
      const slicedRatio = (contrast(gcRC1, gcRC2) + '').substring(0,4)
      setColourRatio(slicedRatio)
        if (slicedRatio >= 4.5 && slicedRatio <= 7 )
        {
          setColourRating("AA")
          trackCustomEvent({
            category: "Colour Contrast Result",
            action: "AAA",
            label: "Colour Contrast Checker",
          })
        }
       else if (slicedRatio >= 7)
        {
          setColourRating("AAA")
          trackCustomEvent({
            category: "Colour Contrast Result",
            action: "AAA",
            label: "Colour Contrast Checker",
          })
        }
      else
      {
        setColourRating("Fail")
        trackCustomEvent({
          category: "Colour Contrast Result",
          action: "Fail",
          label: "Colour Contrast Checker",
        })
      }
      }
  }
  trackCustomEvent({
    category: "Colour Contrast Checker",
    action: "Click",
    label: "Colour Contrast Checker",
  })
}
const handleForeground = e => {
  setColourForeground(e.target.value)
}

const handleBackground = e => {
  setColourBackground(e.target.value)
}

const generateURL = () => {
  const generated = window.location + "?fg=" +  colourForeground + "&bg=" + colourBackground
  console.log(generated)
  // console.log("fg" + getQueryVariable('fg'))
  // console.log("bg" + getQueryVariable('bg'))
}

return (
<div className={conStyles.clrcntChck} style={{color: colourForeground, backgroundColor: colourBackground}}>

<div className={conStyles.introContainer}>
<h3>Sample Text</h3>
  <p className="tblQuo">"The power of the Web is in its universality. Access by everyone regardless of disability is an essential aspect"</p>
  <p className="tblPer">Tim Berners Lee</p>
</div>
<div className={conStyles.inputContainer}>
<p>Enter the <b>hex code</b> for each colour or use the <b>colour picker</b>, to find out if these are accessible.</p>

<div className={conStyles.inputs}>
  <div className={conStyles.foreground}>
      <label htmlFor="foreground">Foreground Colour</label>
      <div className={conStyles.picker}>
        <input type="text" onChange={handleForeground} id="foreground" value={colourForeground} />
        <input type="color" onChange={handleForeground} id="foregroundpicker" name="foregroundpicker" value={colourForeground} />
      </div>
  </div>
  <div className={conStyles.background}>
      <label htmlFor="background">Background Colour</label>
      <div className={conStyles.picker}>
        <input type="text" onChange={handleBackground} id="background" value={colourBackground} />
        <input type="color" onChange={handleBackground} id="backgroundpicker" name="backgroundpicker" value={colourBackground} />
      </div>
  </div> 

  <button className={conStyles.btnAuto + " nBtn button" }  onClick={handleClick}>Check Colours</button>

</div>

<div className="boxes">

  <div className={conStyles.ainf}>Accessibility Information</div>
<div className={conStyles.bxCont}>
<div className={conStyles.bxStyle}>
    <div className={conStyles.bxTitle}>Overall Rating</div>
    <div className={`${colourRatio < 4.5 ? 'bxFail' : 'bxPass' }`}>
      <span className={conStyles.ratingBox}>
        <div className={conStyles.rating}>{colorRating}</div> 
        <div className={conStyles.ratioNum}>{colourRatio}</div>
      </span>
    </div>
  </div>

  <div className={conStyles.bxStyle}>
    <div className={conStyles.bxTitle}>AA Standard</div>
    <div className={conStyles.criteria}>
      <div className={conStyles.pasfail}>
        <div>Normal Text</div>
        <div className={conStyles.ratio + `${colourRatio < 4.5 ? ' fail' : ' pass' }`}> {`${colourRatio < 4.5 ? 'FAIL' : 'PASS'}`}</div>
      </div>
      <div className={conStyles.pasfail}>
        <div>Large Text</div>
        <div className={conStyles.ratio + `${colourRatio < 3 ? ' fail' : ' pass' }`}> {`${colourRatio < 3 ? 'FAIL' : 'PASS'}`} </div>
      </div>
    </div>
  </div>


  <div className={conStyles.bxStyle}>
    <div className={conStyles.bxTitle}>AAA Standard</div>
    <div className={conStyles.criteria}>
      <div className={conStyles.pasfail}>
        <div>Normal Text</div>
        <div className={conStyles.ratio + `${colourRatio < 7 ? ' fail' : ' pass' }`}>{`${colourRatio < 7 ? 'FAIL' : 'PASS' }`} </div>  </div>
      <div className={conStyles.pasfail}>
        <div>Large Text</div>
        <div className={conStyles.ratio + `${colourRatio < 4.5 ? ' fail' : ' pass' }`}>{`${colourRatio < 4.5 ? 'FAIL' : 'PASS' }`}</div>
      </div>
    </div>
  </div>
  </div>
</div>  
</div>

</div>
        )
    }; 
     
export default AccessibilityChecker;
